/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type SuggestionBodyAutopilot_eventTime = {
    readonly type: EventTimeType;
    readonly dateOrDateTime: string;
    readonly timeZone: string | null;
    readonly millis: number;
    readonly offsetMinutes: number | null;
    readonly " $refType": "SuggestionBodyAutopilot_eventTime";
};
export type SuggestionBodyAutopilot_eventTime$data = SuggestionBodyAutopilot_eventTime;
export type SuggestionBodyAutopilot_eventTime$key = {
    readonly " $data"?: SuggestionBodyAutopilot_eventTime$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyAutopilot_eventTime">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyAutopilot_eventTime",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        }
    ],
    "type": "EventTime",
    "abstractKey": null
} as any;
(node as any).hash = 'a63b2219a694f9a6bd4c7bb96c2c5f34';
export default node;
